import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { REPORT_PROGRESS, REPORT_READY } from '../../../Common/Assets/images';
import ReportProgressStyled from './ReportProgressStyled';

const ReportProgress = ({ singleUser, isInProgress, completedCount, totalCount }) => {
  let progressPercentage = 0;
  const renderImage = useMemo(() => {
    const image = {
      completed: { src: REPORT_READY?.src, width: 25, height: 25 },
      noprogress: { src: REPORT_PROGRESS?.src, width: 16.5, height: 20.25 },
    };
    // eslint-disable-next-line react/display-name
    return (type, cls) => (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        className={cls}
        src={image[type]?.src}
        width={image[type]?.width}
        height={image[type]?.height}
        alt="lab test progress"
      />
    );
  }, []);

    if (singleUser) {
      if (completedCount === 0) {
        progressPercentage = 0.01;
      } else {
        progressPercentage = Math.floor((completedCount / totalCount) * 100);
      }
    } else {
      progressPercentage = 100;
    }

  return (
    <ReportProgressStyled>
      <CircularProgressbarWithChildren
        value={progressPercentage}
        strokeWidth={12}
        styles={buildStyles({
          pathColor: '#178EAB',
          trailColor: 'rgba(23, 142, 171, 0.4)',
        })}
      >
        {isInProgress && completedCount !== 0 && (
          <div className="progress_title">
            <span>{progressPercentage}%</span>
          </div>
        )}
        {!isInProgress && <div className="progress_title">{renderImage('completed', '')}</div>}
        {isInProgress && completedCount === 0 && (
          <div className="progress_title">{renderImage('noprogress', 'noProgress')}</div>
        )}
      </CircularProgressbarWithChildren>
    </ReportProgressStyled>
  );
};

ReportProgress.propTypes = {
  completedCount: PropTypes.number,
  isInProgress: PropTypes.bool,
  singleUser: PropTypes.bool,
  totalCount: PropTypes.number,
};

ReportProgress.defaultProps = {
  isInProgress: true,
  completedCount: 0,
  totalCount: 0,
  singleUser: false,
};

export default ReportProgress;
